/*
 * MCRO001-F0050 / T-MCRO-050 — the `suggest` kind renderer.
 * An edit suggestion (ours = proposed, theirs = current) that the author accepts or
 * rejects with the SAME picker: accept = choose ours, reject = choose theirs. Reuses
 * ResolvePicker so a suggestion and a conflict share one component and serialization.
 */

import React from 'react';
import ResolvePicker from './ResolvePicker';

export default function SuggestionPicker(props) {
  return <ResolvePicker {...props} />;
}
